var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfessional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#553788",
    d: "M15 31c0 2.209-.791 4-3 4H5c-4 0-4-14 0-14h7c2.209 0 3 1.791 3 4v6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9266CC",
    d: "M34 33h-1V23h1a1 1 0 1 0 0-2H10c-4 0-4 14 0 14h24a1 1 0 1 0 0-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M34.172 33H11c-2 0-2-10 0-10h23.172c1.104 0 1.104 10 0 10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M11.5 25h23.35c-.135-1.175-.36-2-.678-2H11c-1.651 0-1.938 6.808-.863 9.188C9.745 29.229 10.199 25 11.5 25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#269",
    d: "M12 8a4 4 0 0 1-4 4H4C0 12 0 1 4 1h4a4 4 0 0 1 4 4v3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M31 10h-1V3h1a1 1 0 1 0 0-2H7C3 1 3 12 7 12h24a1 1 0 1 0 0-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M31.172 10H8c-2 0-2-7 0-7h23.172c1.104 0 1.104 7 0 7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M8 5h23.925c-.114-1.125-.364-2-.753-2H8C6.807 3 6.331 5.489 6.562 7.5C6.718 6.142 7.193 5 8 5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4900C",
    d: "M20 17a4 4 0 0 1-4 4H6c-4 0-4-9 0-9h10a4 4 0 0 1 4 4v1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M35 19h-1v-5h1a1 1 0 1 0 0-2H15c-4 0-4 9 0 9h20a1 1 0 1 0 0-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M35.172 19H16c-2 0-2-5 0-5h19.172c1.104 0 1.104 5 0 5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M16 16h19.984c-.065-1.062-.334-2-.812-2H16c-1.274 0-1.733 2.027-1.383 3.5c.198-.839.657-1.5 1.383-1.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.99836bfcb3e0f17f6b5bd06ecd46be03.svg";
export { ForwardRef as ReactComponent };